import { usePaginatedQuery } from 'react-query'
import { LegendRepository } from 'repository/legend'

export const useFetchLegends = (layerIds: number[], options?: any) => {
  const { status, resolvedData, latestData = [], error } = usePaginatedQuery(
    layerIds.length > 0 && ['legends', { layerIds }],
    () => LegendRepository.fetchLegends(layerIds),
    {
      retry: false,
      ...options,
    },
  )

  return {
    status,
    legends: resolvedData ?? latestData,
    error,
  }
}
